import React, { useState } from "react";
import { MailCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth, errMsg } from "@/context/AuthContext";

export default function EmailVerifyBanner() {
  const { user, resendVerification } = useAuth();
  const [busy, setBusy] = useState(false);

  const resend = async () => {
    setBusy(true);
    try {
      await resendVerification();
      toast.success(`Lien envoyé à ${user.email}`);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="border-t border-[#EAD9B8] bg-[#FFF8EA]" data-testid="email-verify-banner">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-x-4 gap-y-2 px-5 py-2.5 text-sm text-[#7A5410] md:px-8">
        <MailCheck size={16} className="shrink-0" />
        <span className="flex-1">Confirme ton adresse e-mail pour sécuriser ton compte.</span>
        <button onClick={resend} disabled={busy} data-testid="email-verify-resend-btn"
          className="inline-flex min-h-10 items-center gap-1.5 rounded-full bg-white px-4 font-semibold text-[#9A6B12] transition-colors hover:bg-[#FBEFD6] disabled:opacity-60">
          {busy && <Loader2 size={14} className="animate-spin" />} Renvoyer le lien
        </button>
      </div>
    </div>
  );
}
